import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-148934f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"width":"100%"} }
const _hoisted_2 = {
  class: "left-align",
  style: {"padding-left":"3vh","padding-top":"8vh"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { style: {"margin":"4rem 0"} }, "Start Your Dream In Australia", -1))

import { useRoute, useRouter } from 'vue-router';
    
export default /*#__PURE__*/_defineComponent({
  __name: 'Background-wap',
  setup(__props) {

    const router = useRouter();
    const redirect = (path: string) => {
      router.push(path);
    }

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, {
      class: "custom-card",
      "body-style": "padding:0;"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, { style: {"height":"100vh"} }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              span: 12,
              style: {"background-color":"rgba(27, 43, 64, 0.2)"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("h3", {
                    class: "selectable",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (redirect('/education-wap')))
                  }, "Education"),
                  _createElementVNode("h3", {
                    class: "selectable",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (redirect('/training-wap')))
                  }, "Training"),
                  _createElementVNode("h3", {
                    class: "selectable",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (redirect('/employment-wap')))
                  }, "Employment"),
                  _hoisted_3,
                  _createElementVNode("button", {
                    class: "btn button-23",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (redirect('/contact-wap')))
                  }, "CONTACT US")
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})